<h1 mat-dialog-title
    i18n="Contest Tasks Editor|Contest Question details modal title@@contest-tasks-editor-question-details-modal-title">
  Question Details
</h1>
<div mat-dialog-content #dialogContent class="full-width">
  <p class="mat-small">
    <ng-container i18n="Contest Tasks Editor|Contest question math info@@contest-tasks-editor-question-math-info">
      Question text and answers support LaTeX mathematics inline (within text) formulas ($...$) and displayed equations
      ($$...$$). More info about LaTex expressions
    </ng-container>
    <app-link href="https://en.wikibooks.org/wiki/LaTeX/Mathematics"
              [external]="true"
              label="here"
              i18n-label="General|General URL here label@@general-url-here-label"></app-link>
  </p>
  <form [formGroup]="questionForm" (ngSubmit)="proceed()">
    <div class="editor">
      <editor *ngIf="initEditor"
              [formControl]="questionField"
              [apiKey]="editorApiKey"
              [init]="editorConfig"
              [disabled]="questionField.disabled"></editor>
      <mat-error *ngIf="questionField.hasError('maxlength') && questionField.dirty" class="mat-small">
        <ng-container
          i18n="Form Validation|Invalid contest question max length@@form-validation-input-invalid-contest-question-max">
          Question HTML code should contain less than 5120 characters
        </ng-container>
      </mat-error>
    </div>

    <!-- Image -->
    <mat-label i18n="Contest Tasks Editor|Question image label@@contest-tasks-editor-question-image-label"
               class="mat-small text-disabled-color">
      Question image:
    </mat-label>

    <file-upload *ngIf="!question.image" acceptTypes=".png,.jpg,.jpeg,.gif" fileTypes="*.png, *.jpg, *.gif"
                 (fileSelected)="onImageFileSelected($event)"></file-upload>
    <div *ngIf="question.image" class="question-image-holder">
      <app-button icon="delete" [secondary]="true" [destructive]="true" class="delete-image-btn"
                  (clicked)="question.image = undefined; $event.preventDefault();"></app-button>
      <img [src]="question.image" class="question-image" alt="question-image">
    </div>
    <!--  Image end  -->

    <!-- Audio -->
    <mat-label i18n="Contest Tasks Editor|Question audio label@@contest-tasks-editor-question-audio-label"
               class="mat-small text-disabled-color">
      Question audio:
    </mat-label>

    <file-upload *ngIf="!question.audio" acceptTypes=".mp3" fileTypes="*.mp3"
                 (fileSelected)="onAudioFileSelected($event)"></file-upload>
    <div *ngIf="question.audio" class="question-audio-holder">
      <app-button icon="delete" [secondary]="true" [destructive]="true" class="delete-image-btn"
                  (clicked)="question.audio = undefined; $event.preventDefault();"></app-button>
      <media-playback [audioUrl]="question.audio"></media-playback>
    </div>
    <!--  Audio end  -->

    <!-- Video -->
    <mat-label i18n="Contest Tasks Editor|Question video label@@contest-tasks-editor-question-video-label"
               class="mat-small text-disabled-color">
      Question video:
    </mat-label>

    <file-upload *ngIf="!question.video" acceptTypes=".mp4" fileTypes="*.mp4"
                 (fileSelected)="onVideoFileSelected($event)"></file-upload>
    <div *ngIf="question.video" class="question-video-holder">
      <app-button icon="delete" [secondary]="true" [destructive]="true" class="delete-image-btn"
                  (clicked)="question.video = undefined; $event.preventDefault();"></app-button>
      <media-playback [videoUrl]="question.video"></media-playback>
    </div>
    <!--  Video end  -->

    <form-input [control]="pointsField"
                class="full-width"
                type="number"
                label="Question points:"
                i18n-label="Contest Tasks Editor|Question points input label@@contest-tasks-editor-question-points-input-label"
                placeholder="Question points..."
                i18n-placeholder="Contest Tasks Editor|Question points input placeholder@@contest-tasks-editor-question-points-input-placeholder"
                [min]="1" [maxLength]="127"></form-input>


    <item-select [roles]="roles"
                 label="Question type:"
                 i18n-label="Contest Tasks Editor|Contest question type input label@@contest-tasks-editor-question-type-input-label"
                 [compareWith]="compareTypes"
                 [displayWith]="displayType"
                 [loadWith]="loadTypes"
                 [selectedItem]="typeField.value"
                 [disabled]="localizeMode"
                 (selected)="handleQuestionTypeChange($event)"></item-select>

    <mat-label *ngIf="typeField.value"
               i18n="Contest Tasks Editor|Question answers label@@contest-tasks-editor-question-answers-label"
               class="mat-small text-disabled-color">
      Question answers (mark correct answers):
    </mat-label>

    <mat-selection-list *ngIf="typeField.value == MULTIPLE_CHOICE && !localizeMode" class="no-focus"
                        (selectionChange)="setAnswerCorrect($event)">
      <mat-list-option *ngFor="let answer of question.answers" class="list-option mat-small no-focus"
                       checkboxPosition="before"
                       [value]="answer"
                       [selected]="answer.correct">
        <div>
          <form-input *ngIf="answer.id"
                      [control]="getAnswerControl(answer)"
                      class="full-width list-form-input"
                      label="Answer"
                      i18n-label="Contest Tasks Editor|Answer text input label@@contest-tasks-editor-answer-text-input-label"
                      placeholder="Answer..."
                      i18n-placeholder="Contest Tasks Editor|Answer text input placeholder@@contest-tasks-editor-answer-text-input-placeholder"
                      [compact]="true"
                      [minLength]="1" [maxLength]="256"
                      (keydown)="$event.stopPropagation()"
                      (click)="$event.stopPropagation();"></form-input>
          <app-button icon="delete"
                      [secondary]="true"
                      [destructive]="true"
                      class="delete-btn list"
                      (clicked)="handleAnswerDelete(answer); $event.preventDefault();"></app-button>
        </div>
      </mat-list-option>
    </mat-selection-list>
    <mat-list *ngIf="typeField.value == MULTIPLE_CHOICE && localizeMode" class="no-focus">
      <mat-list-item *ngFor="let answer of question.answers" class="list-option mat-small no-focus">
        <div class="full-width">
          <mat-pseudo-checkbox [disabled]="true"
                               [state]="answer.correct ? 'checked' : 'unchecked'"
                               class="localize-checkbox"></mat-pseudo-checkbox>
          <form-input *ngIf="answer.id"
                      [control]="getAnswerControl(answer)"
                      class="full-width list-form-input"
                      label="Answer"
                      i18n-label="Contest Tasks Editor|Answer text input label@@contest-tasks-editor-answer-text-input-label"
                      placeholder="Answer..."
                      i18n-placeholder="Contest Tasks Editor|Answer text input placeholder@@contest-tasks-editor-answer-text-input-placeholder"
                      [compact]="true"
                      [minLength]="1" [maxLength]="256"
                      (click)="$event.stopPropagation();"></form-input>
        </div>
      </mat-list-item>
    </mat-list>

    <mat-list *ngIf="typeField.value == SINGLE_CHOICE && !localizeMode" class="no-focus">
      <mat-radio-group (change)="setSingleAnswerCorrect($event.value)">
        <mat-list-item *ngFor="let answer of question.answers" class="list-option no-focus">
          <mat-radio-button color="primary" class="full-width mat-small"
                            [checked]="answer.correct"
                            [disabled]="localizeMode"
                            [value]="answer">
            <form-input *ngIf="answer.id"
                        [control]="getAnswerControl(answer)"
                        class="full-width mat-small"
                        label="Answer"
                        i18n-label="Contest Tasks Editor|Answer text input label@@contest-tasks-editor-answer-text-input-label"
                        placeholder="Answer..."
                        i18n-placeholder="Contest Tasks Editor|Answer text input placeholder@@contest-tasks-editor-answer-text-input-placeholder"
                        [minLength]="1" [maxLength]="128"
                        (click)="$event.stopPropagation();"></form-input>
          </mat-radio-button>
          <app-button icon="delete"
                      [secondary]="true"
                      [destructive]="true"
                      class="delete-btn"
                      (clicked)="handleAnswerDelete(answer); $event.preventDefault();"></app-button>
        </mat-list-item>
      </mat-radio-group>
    </mat-list>
    <mat-list *ngIf="typeField.value == SINGLE_CHOICE && localizeMode" class="no-focus">
      <mat-list-item *ngFor="let answer of question.answers" class="list-option no-focus">
        <div class="full-width">
          <mat-radio-button color="primary"
                            [checked]="answer.correct"
                            [disabled]="true"></mat-radio-button>
          <form-input *ngIf="answer.id"
                      [control]="getAnswerControl(answer)"
                      class="full-width list-form-input mat-small"
                      label="Answer"
                      i18n-label="Contest Tasks Editor|Answer text input label@@contest-tasks-editor-answer-text-input-label"
                      placeholder="Answer..."
                      i18n-placeholder="Contest Tasks Editor|Answer text input placeholder@@contest-tasks-editor-answer-text-input-placeholder"
                      [minLength]="1" [maxLength]="128"></form-input>
        </div>
      </mat-list-item>
    </mat-list>

    <div class="center-align">
      <mat-error *ngIf="typeField.value && question.answers.length < 2" class="left-align"
                 i18n="Contest Tasks Editor|Question not enough answers error@@contest-tasks-editor-question-not-enough-answers-error">
        Question should provide at least 2 answers
      </mat-error>
      <mat-error *ngIf="typeField.value && question.answers.length >= 2 && !hasCorrectAnswer" class="left-align"
                 i18n="Contest Tasks Editor|Question no correct answer error@@contest-tasks-editor-question-no-correct-answer-error">
        At least one answer should be marked as correct
      </mat-error>
      <mat-error *ngIf="typeField.value && hasSameAnswer" class="left-align"
                 i18n="Contest Tasks Editor|Question same answers error@@contest-tasks-editor-question-same-answers-error">
        Answers should be different
      </mat-error>

      <app-button *ngIf="!localizeMode"
                  icon="add"
                  [disabled]="!typeField.value"
                  [secondary]="true"
                  (clicked)="addAnswer(); $event.preventDefault();"></app-button>
    </div>
  </form>
</div>
<div mat-dialog-actions>
  <app-button (clicked)="cancelUpdate()"
              [secondary]="true"
              label="Cancel"
              i18n-label="General|Cancel action label@@general-cancel-action-label"></app-button>
  <span class="btn-spacer"></span>
  <app-button [disabled]="inProgress || !proceedAllowed()"
              (clicked)="proceed()"
              label="Save"
              i18n-label="General|Save action label@@general-save-action-label"></app-button>
</div>
